
import initialState, { ISessionState } from '../modules/session/ISessionState';
import { USER_AUTHENTICATION_UPDATE, USER_LOGGED_OUT } from '../modules/session/session.action.const';
import { userAuthenticationUpdate, userLoggedOut } from '../modules/session/session.reducer.logic';

export function sessionReducer(state: ISessionState = initialState, action) {
    switch (action.type) {
        case USER_AUTHENTICATION_UPDATE:
            return userAuthenticationUpdate(state, action);

        case USER_LOGGED_OUT:
            return userLoggedOut(state, action);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/session.reducer.ts